import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Input,
} from 'reactstrap'
import get from 'lodash/get'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'

class AddChangeRequestForm extends React.Component {
  render() {
    const open = get(this.props, 'open')
    const toggle = get(this.props, 'toggle')
    const handleInput = get(this.props, 'handleInput')
    const change_request_man_days = get(this.props, 'change_request_man_days')
    const change_request_price = get(this.props, 'change_request_price')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <ModalHeader toggle={ () => toggle() }>
          <HeadLabel>Add Change Request</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TeaxtLabel >QT/PO No.</TeaxtLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="change_request_qt"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TeaxtLabel >Change Request</TeaxtLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="change_request_name"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TeaxtLabel >Description</TeaxtLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="change_request_description"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TeaxtLabel >Man-Days</TeaxtLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <NumberFieldSub
                          name="change_request_man_days"
                          value={ change_request_man_days }
                          allowEmptyFormatting={ true }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onBlur={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleInput(e)
                          } }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TeaxtLabel >Sale Price (฿)</TeaxtLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <NumberFieldSub
                          name="change_request_price"
                          value={ change_request_price }
                          allowEmptyFormatting={ true }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onBlur={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleInput(e)
                          } }
                        />
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddChangeRequestForm

const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const HeadLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    color: #AD2624;
`
const TeaxtLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 14px ;
    color: #404040;
`
const NumberFieldSub = styled(NumberFormat)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height: 100%;
    font-size: 12px ;
    border-radius: 5px;
    border: ${props => {
    if (props.invalid) {
      return '1px solid red'
    }
    return '1px solid #CCCCCC'
  }};
    background-color: ${props => {
    const status = props.disabled
    if (status === !get(this.props, 'edit_resource')) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/add-change-request/index.js